import React from "react";
import { Button, Label } from "usebeauty";
import { useRoutes } from "@router/Router";
import { useOCRContext } from "@context/OCRContext";
import { Back, ChevronLeft, Close } from "@Icons";
import IdCard from "./contents/IdCard";
import Driver from "./contents/Driver";
import PassportKor from "./contents/PassportKor";
import PassportForeign from "./contents/PassportForeign";
import Alien from "./contents/Alien";
import "./OCRResultPage.scss";

const OCRResultPage = () => {
  const { step, navigate } = useRoutes();
  const ocrContext = useOCRContext();
  const { result } = ocrContext;

  // const ssaResult = ocrContext.result.ocr_result.id_truth === "REAL";

  return (
    <div className="alchera-ocr-result">
      <div className="navigation">
        {step.prev && (
          <i onClick={() => navigate("prev")}>
            <Back st={{ fontSize: "16px" }} />
          </i>
        )}
        <Label text={step.label}></Label>
        <i onClick={() => window.location.reload()}>
          <Close st={{ fontSize: "16px" }} />
        </i>
      </div>
      <div className="container">
        <div className="ocr-result-image">
          <img src={result.ocr_origin_image || ""} alt="ocr origin image" />
        </div>
        <div className="ocr-result-ocr">
          <div className="title">
            <h4>인식결과</h4>
          </div>
          {result.ocr_type === "idcard-ssa" &&
            (Object.hasOwnProperty.call(result.ocr_result, "driver_number") ? <Driver /> : <IdCard />)}
          {result.ocr_type === "passport-ssa" && <PassportKor />}
          {result.ocr_type === "foreign-passport-ssa" && <PassportForeign />}
          {result.ocr_type === "alien-ssa" && <Alien />}
        </div>
      </div>

      <div className="footer">
        <div className="steps">
          <span>Step 2</span>
          <div className="step">
            <div className="level prev"></div>
            <div className="level current"></div>
            <div className="level"></div>
            <div className="level"></div>
          </div>
        </div>
        <Button onClick={() => navigate("next")} ripple={false}>
          <span>다음</span>
          <ChevronLeft st={{ fontSize: "20px" }} />
        </Button>
      </div>
    </div>
  );
};

export default OCRResultPage;
